import { render, staticRenderFns } from "./DoctorsList.vue?vue&type=template&id=33bee5ea"
import script from "./DoctorsList.vue?vue&type=script&lang=js"
export * from "./DoctorsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports